module.exports = __webpack_public_path__ + "static/media/TermsIcon.53bbb760.png";